<template>
  <div class="row storage">
    <div class="col">
      <div class="row storage__head">
        <div class="col-8 storage__stats">
          <div class="d-inline-flex flex-column">
            <div class="d-flex">
              <div class="storage__stats-block storage__stats-block--left">
                <label>Осталось:</label>
                <p>{{ leftSize }}</p>
              </div>
              <div class="storage__stats-block storage__stats-block--used">
                <label>Использовано:</label>
                <p>{{ usedSize }}</p>
              </div>
              <div class="storage__stats-block storage__stats-block--all">
                <label>План:</label>
                <p>{{ allSize }}</p>
              </div>
            </div>
            <div class="storage__stats-progress mt-2">
              <div
                class="storage__stats-progress-status"
                :style="{ width: progressPercent + '%' }"
              ></div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div
            class="d-flex flex-column align-items-end justify-content-between h-100"
          >
            <form class="form-inline py-2" @submit.prevent>
              <div class="input-group with-clear-icon">
                <input type="text" class="form-control" v-model="searchText" />
                <i
                  class="ico ico-close"
                  @click="clearSearchText"
                  v-if="searchText.length > 0"
                ></i>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>
            </form>
            <button
              type="button"
              class="btn btn-outline-primary px-4"
              v-if="selectedFileIds.length > 0"
              @click="deleteFiles"
            >
              <i class="ico ico-delete"></i>
              удалить {{ selectedFileIds.length }} шт.
            </button>
          </div>
        </div>
      </div>
      <div class="row storage__table">
        <div class="col">
          <table class="table clients-table mt-5">
            <thead>
              <tr>
                <th
                  v-for="item in tableHeaderItems"
                  :key="item.id"
                  v-show="item.isVisible"
                  :class="{
                    'sort-asc':
                      item.name === sortFieldName && sortType === 'ASC',
                    'sort-desc':
                      item.name === sortFieldName && sortType === 'DESC',
                    sort:
                      item.name !== sortFieldName && item.name !== 'selected',
                  }"
                  :style="{
                    width:
                      (item.width * 100) /
                        tableHeaderItems
                          .map((x) => x.width)
                          .reduce((a, b) => a + b) +
                      '%',
                  }"
                  @click="sortFiles(item.name)"
                >
                  <div class="table-th">
                    <template v-if="item.name === 'selected'">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          id="rowsSelect"
                          class="custom-control-input"
                          @input="toggleFilesSelect"
                          :checked="isAllFilesSelected"
                        />
                        <label
                          class="custom-control-label"
                          for="rowsSelect"
                        ></label>
                      </div>
                    </template>
                    <template v-else>{{ item.viewName }}</template>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(file, index) in filteredFiles" :key="file.id">
                <td v-for="item in tableHeaderItems" :key="item.name">
                  <template v-if="item.name === 'selected'">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        :id="'rowSelect' + index"
                        class="custom-control-input"
                        v-model="file[item.name].value"
                      />
                      <label
                        class="custom-control-label"
                        :for="'rowSelect' + index"
                      ></label>
                    </div>
                  </template>
                  <template v-else-if="item.name === 'taskName'">
                    <router-link
                      v-if="file[item.name].value.id"
                      :to="`/view-task/${file[item.name].value.id}`"
                      >{{ file[item.name].value.name }}</router-link
                    >
                    <span v-else>{{ file[item.name].value.name }}</span>
                  </template>
                  <template v-else-if="item.name === 'fileName'">
                    <a :href="`/api/file-manager/files/${file.id}/download`">{{
                      file[item.name].value
                    }}</a>
                  </template>
                  <template v-else>{{ file[item.name].value }}</template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce, sortBy } from 'lodash'
import api from '../../api'
import roles from '../../helpers/userRoles'
import moment from 'moment'

const sizeOf = function (bytes) {
  if (!bytes) {
    return '0.00 B'
  }
  var e = Math.floor(Math.log(bytes) / Math.log(1024))
  return (
    (bytes / Math.pow(1024, e)).toFixed(2) + ' ' + ' KMGTP'.charAt(e) + 'B'
  )
}

export default {
  name: 'Storage',
  data () {
    return {
      searchText: '',
      lazySearchText: '',
      bucket: null,
      files: [],
      sortFieldName: 'dateCreation',
      sortType: 'DESC'
    }
  },
  computed: {
    allSize () {
      return this.bucket ? sizeOf(+this.bucket.quota) : sizeOf(0)
    },
    usedSize () {
      return this.bucket ? sizeOf(+this.bucket.size) : sizeOf(0)
    },
    leftSize () {
      const leftSize = this.bucket ? this.bucket.quota - this.bucket.size : 0
      return sizeOf(leftSize)
    },
    progressPercent () {
      return this.bucket ? (this.bucket.size / this.bucket.quota) * 100 : 0
    },
    sortedFiles () {
      const sortedFiles = sortBy(this.files, (f) => {
        return f[this.sortFieldName].sortValue
      })

      if (this.sortType === 'DESC') {
        return sortedFiles.reverse()
      }

      return sortedFiles
    },
    filteredFiles () {
      if (this.lazySearchText) {
        return this.sortedFiles.filter((f) =>
          Object.values(f).some(
            (x) =>
              x.searchValue &&
              x.searchValue.toLowerCase().indexOf(this.lazySearchText) >= 0
          )
        )
      }
      return this.sortedFiles
    },
    selectedFileIds () {
      return this.filteredFiles
        .filter((f) => f.selected.value)
        .map((f) => f.id)
    },
    isAllFilesSelected () {
      return this.selectedFileIds.length === this.filteredFiles.length
    },
    isCanViewStorage () {
      return (
        this.$store.getters.role === roles.manager ||
        this.$store.getters.role === roles.director
      )
    }
  },
  watch: {
    searchText: debounce(function (newValue) {
      this.lazySearchText = newValue.toLowerCase()
    }, 300)
  },
  created () {
    if (!this.isCanViewStorage) {
      this.$router.push('/')
    }

    this.getStorageFiles()
    this.setTableHeader()
  },
  methods: {
    async getStorageFiles () {
      try {
        const resp = await api.get.storageFiles()
        this.files = resp.data.data.files.map((f) => {
          const clientName =
            f.task && f.task.client
              ? f.task.client.legal_entity
                ? f.task.client.legal_entity.name
                : f.task.client.name
              : '-'
          const taskNumber = f.task ? f.task.ctid.toString() : '-'
          const taskName = f.task ? f.task.name : '-'
          const dateCreation = moment(f.mtime * 1000).format(
            'DD.MM.YYYY HH:mm'
          )
          const creatorName = f.creator
            ? `${f.creator.firstname} ${f.creator.lastname}`
            : '-'

          return {
            id: f.id,
            selected: {
              value: false,
              sortValue: null,
              searchValue: null
            },
            fileName: {
              value: f.name,
              sortValue: f.name,
              searchValue: f.name
            },
            fileSize: {
              value: sizeOf(f.size),
              sortValue: +f.size,
              searchValue: null
            },
            dateCreation: {
              value: dateCreation,
              sortValue: f.mtime,
              searchValue: dateCreation
            },
            taskNumber: {
              value: taskNumber,
              sortValue: taskNumber,
              searchValue: taskNumber
            },
            taskName: {
              value: {
                name: taskName,
                id: f.task ? f.task.id : null
              },
              sortValue: taskName,
              searchValue: taskName
            },
            clientName: {
              value: clientName,
              sortValue: clientName,
              searchValue: clientName
            },
            creatorName: {
              value: creatorName,
              sortValue: creatorName,
              searchValue: creatorName
            }
          }
        })
        this.bucket = resp.data.data.bucket
      } catch (ex) {
        // ignore
      }
    },
    clearSearchText () {
      this.searchText = ''
    },
    setTableHeader () {
      this.tableHeaderItems = [
        {
          name: 'selected',
          viewName: '',
          width: 40,
          isVisible: true
        },
        {
          name: 'fileName',
          viewName: 'Файл',
          width: 175,
          isVisible: true
        },
        {
          name: 'fileSize',
          viewName: 'Размер',
          width: 80,
          isVisible: true
        },
        {
          name: 'dateCreation',
          viewName: 'Дата',
          width: 80,
          isVisible: true
        },
        {
          name: 'creatorName',
          viewName: 'Создатель',
          width: 150,
          isVisible: true
        },
        {
          name: 'clientName',
          viewName: 'Компания',
          width: 150,
          isVisible: true
        },
        {
          name: 'taskName',
          viewName: 'Задача',
          width: 120,
          isVisible: true
        },
        {
          name: 'taskNumber',
          viewName: '№ ',
          width: 50,
          isVisible: true
        }
      ]
    },
    sortFiles (fieldName) {
      if (fieldName === 'selected') {
        return
      }

      if (fieldName === this.sortFieldName) {
        this.sortType = this.sortType === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortFieldName = fieldName
        this.sortType = 'ASC'
      }
    },
    toggleFilesSelect () {
      if (this.isAllFilesSelected) {
        this.filteredFiles.forEach((f) => {
          f.selected.value = false
        })
      } else {
        this.filteredFiles.forEach((f) => {
          f.selected.value = true
        })
      }
    },
    async deleteFiles () {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: async () => {
              try {
                await api.delete.deleteFiles(this.selectedFileIds)
                this.getStorageFiles()
              } catch (ex) {
                this.$notify({
                  message: 'Произошла ошибка',
                  type: 'danger'
                })
              }
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.$eventBus.$emit('pageHeaderChange', 'Хранилище')
    })
  }
}
</script>

<style lang="scss" scoped>
.storage {
  &__stats-block {
    max-width: 150px;
    min-height: 80px;
    border-radius: 4px;
    padding: 15px;

    p {
      font-size: 20px;
    }

    &--left {
      background-color: #e9eef2;
    }
  }

  &__stats-progress {
    position: relative;
    width: 100%;
    height: 10px;
    border-radius: 5px;
    background-color: #eaeff3;
    overflow: hidden;

    &-status {
      background-color: #889dae;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  .table {
    td .custom-checkbox {
      margin-left: 4px;
    }
  }
}
</style>
